<template>
  <h1><span class="text-primary">Privacy Policy</span> of {{ $domain }} Site</h1>
  <AppThirdLayout>
    <h2>Information collection</h2>
    <p>We collect information from you when you fill out forms on the site. The information collected includes your name,
    email address, phone number, and other details that you choose to provide when filling out the form. In addition, we
    automatically receive and save information from your computer and browser, including your IP address, software and
    hardware characteristics, and details of the page you requested to view. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Use of information</h2>
    <p><strong>Any information we collect from you may be used to</strong>:<br />• personalize your experience and respond
    to your individual needs.<br />• provide You have a fast e-Visa issuance for the country of your choice.<br />•
    Provide personalized marketing content.<br />• Improve our website.<br />• Improve your customer service and support
    needs.<br />• Create Contact you via email or phone.<br />• Conduct a contest, promotion, or survey. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>E-Commerce Privacy</h2>
    <p>We are the sole owner of the information collected on the site. The information by which you can be identified will
    not be sold, exchanged, transferred, or given to any other company for any reason without your consent, except for
    information necessary to complete an application and/or transaction, such as issuing an electronic visa. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Transfer of information to a third party</h2>
    <p>We do not sell, trade, or transfer in any way to external entities your personally identifiable information. This
      term does not include qualified third party companies that assist us in operating our website or conducting our
      business. We believe that information sharing is necessary in order to investigate, prevent or act in connection with
      legal activities, suspected fraud, situations involving possible threats to the personal safety of any person,
      violations of our terms of use, or as required by law. Non-personal information, however, may be given to external
      entities for marketing, advertising and other uses.<br />As part of the effort to provide a quick and cheap service to
      the site's customers for the issuance of entry visas, personal information and details, including passport details,
      may be sent to a third party that deals In issuing visas, for example to official government authorities and
      immigration offices. All information transfer is carried out in a secure manner and after checking the reliability of
      the third party. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Information Security</h2>
    <p>
      We implement a variety of up-to-date security measures to keep your personal information safe. We use sophisticated
      encryption to protect sensitive information transmitted over the network. The "{{ SITE_NAME }}" site also protects
      your information offline - only employees who need to perform a specific job (eg customer service or issuing visas)
      are given access to personally identifiable information. The computers/servers used to store personally identifiable
      information are kept in a secure environment according to SSL and PCI standards updated for
      {{ getCurrentYear() }}.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Do we use cookies?</h2>
    <p>Yes. Our cookies improve access to our website and identify repeat visitors. Furthermore, our cookies improve the
      user experience by tracking and targeting her/his interests. The use of cookies, however, is not linked in any way to
      any personally identifiable information on our site. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Removal from database</h2>
    <p>We use the email address you provided to send you information and updates regarding your order, occasional company
      news, related product information, etc. If at some point you would prefer to remove yourself from the mailing list, in
      order not to receive emails in the future, we include detailed instructions for removing yourself from the mailing
      list at the bottom of each email. In addition, you can contact us at any time with a request for removal and we will
      carry it out within three business days. </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Deletion of personal content from the server</h2>
    <p>Photos and/or sensitive information that site users upload to the server as part of the process of filling out a form
      or receiving a service, will be deleted shortly after the end of the service (for example, sending a visa by email).
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>Agreement</h2>
    <p>By using our site, you agree to our privacy policy.</p>
  </AppThirdLayout>
</template>

<script setup lang="ts">
import { getCurrentYear } from '~/helpers/date';
import { SITE_NAME } from '~/assets/constants';
</script>